import React from 'react';
import { ClientClipperModel, clientClipperModelInitial } from '../../../Models/ClientClipperModel';
import { ClipperModel } from '../../../Models/ClipperModel';

export interface IClientClipperContextProps {
    currentClientClipperIndex: number,
    setCurrentClientClipperIndex: (value: number) => void,
    clipperList: ClipperModel[],
    setClipperList: (value: ClipperModel[]) => void    
    currentClipper: ClipperModel | null
    setCurrentClipper: (value: ClipperModel | null) => void    
    currentClientClipper: ClientClipperModel
    setCurrentClientClipper: (value: ClientClipperModel) => void    
    isClipperModalOpen: boolean
    setIsClipperModalOpen: (value: boolean) => void    
    clipperEditMode: boolean
    setClipperEditMode: (value: boolean) => void    
}

export const ClientClipperContextInitial: IClientClipperContextProps = {
    currentClientClipperIndex: -1,
    setCurrentClientClipperIndex: () => { ''; },
    clipperList: [],
    setClipperList: () => { ''; },
    currentClipper: null,
    setCurrentClipper: () => { ''; },
    currentClientClipper: clientClipperModelInitial,
    setCurrentClientClipper: () => { ''; },
    isClipperModalOpen: false,
    setIsClipperModalOpen: () => { ''; },
    clipperEditMode: false,
    setClipperEditMode: () => { ''; },
};

export const ClientClipperContext = React.createContext(ClientClipperContextInitial);
